import { useState } from 'react';
import StepWizard from 'react-step-wizard';
import { NSModal } from 'bricks';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { IOptionAnyValue } from 'bricks/types';
import useAuthContext from 'contexts/AuthContext';
import { useCreateProForma } from 'queries/ProForma';
import { URLS } from 'services/urls';
import CreateProFormaStep1 from './components/CreateProFormaStep1/CreateProFormaStep1';
import { CREATE_PRO_FORMA_STEPS } from './constants';
import { getLocalStorage, storeLocalStorage } from 'helpers/localStorage/helpers';
import { GlobalKeys } from 'helpers/localStorage/constants';
import { ProFormaModelIds } from 'constants/proForma';

export interface ICreateProFormaModalProps {
    toggle: () => void;
    isOpen: boolean;
    initialScenario?: IOptionAnyValue;
    dealAssetTypeCorrelationId?: string;
    dealId?: number;
}

const CreateProFormaModal = ({
    toggle,
    isOpen,
    initialScenario,
    dealAssetTypeCorrelationId,
    dealId: selectedDealId,
}: ICreateProFormaModalProps) => {
    const { dealId: dealIdFromParams } = useParams<{ dealId: string }>();
    const dealId = selectedDealId ? String(selectedDealId) : dealIdFromParams;
    const { selectedOrganizationId } = useAuthContext();
    const navigate = useNavigate();

    const [proFormaModelId, setProFormaModelId] = useState<number | undefined>(undefined);
    const [selectedScenario, setSelectedScenario] = useState<IOptionAnyValue | undefined>(initialScenario);

    const { mutate: createProForma, isPending: isCreatingProForma } = useCreateProForma();

    const handleCreateProForma = () => {
        createProForma(
            {
                dealId: Number(dealId),
                selectedOrganizationId: String(selectedOrganizationId),
                scenarioId: selectedScenario?.value ? Number(selectedScenario.value) : undefined,
                proFormaModelId,
            },
            {
                onSuccess: data => {
                    if (data.proFormaModelId === ProFormaModelIds.APARTMENT_WITH_RETAIL) {
                        const proFormaIds = getLocalStorage<number[]>(GlobalKeys.ApartmentRetailReviewBadgeProformaIds) || [];
                        storeLocalStorage(GlobalKeys.ApartmentRetailReviewBadgeProformaIds, [...proFormaIds, data.id]);
                    }

                    const path = generatePath(URLS.PRO_FORMA.TABLE, {
                        dealId,
                        proFormaId: data.id.toString(),
                    });
                    navigate(path);
                },
                onError: error => {
                    console.error('Error creating pro forma:', error);
                },
            },
        );
    };

    return (
        <NSModal
            toggle={toggle}
            isOpen={isOpen}
            modalHeaderClassName="bg-primary modal-colored-header"
            modalHeaderText="Generate pro forma"
            modalFooterIsShown={false}
            size="lg"
        >
            <StepWizard
                key={initialScenario ? 'with-scenario' : 'without-scenario'}
                initialStep={CREATE_PRO_FORMA_STEPS.STEP_1}
                transitions={{
                    enterRight: '',
                    exitRight: '',
                }}
            >
                <CreateProFormaStep1
                    stepName={String(CREATE_PRO_FORMA_STEPS.STEP_1)}
                    dealId={Number(dealId)}
                    toggle={toggle}
                    initialScenario={initialScenario}
                    setProFormaModelId={setProFormaModelId}
                    proFormaModelId={proFormaModelId}
                    selectedScenario={selectedScenario}
                    setSelectedScenario={setSelectedScenario}
                    handleCreateProForma={handleCreateProForma}
                    isCreatingProForma={isCreatingProForma}
                    dealAssetTypeCorrelationId={dealAssetTypeCorrelationId}
                />
            </StepWizard>
        </NSModal>
    );
};

export default CreateProFormaModal;

